import { render, staticRenderFns } from "./LoginDecorationIcon.vue?vue&type=template&id=645262c7&scoped=true&"
import script from "./LoginDecorationIcon.vue?vue&type=script&lang=js&"
export * from "./LoginDecorationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645262c7",
  null
  
)

export default component.exports